import { RoutePaths } from 'types/enums';
import { SlideTypes } from '../types';

export const getViewCtaLink = (
    toLocalizedPath: (path: string) => string,
    type?: SlideTypes,
    slug?: string,
) => {
    let to;

    if (!type || !slug) {
        return '';
    }

    switch (type) {
        case SlideTypes.Labels:
            to = toLocalizedPath(`/${RoutePaths.Labels}/${slug}`);
            break;

        case SlideTypes.Packs:
            to = toLocalizedPath(`/${RoutePaths.Packs}/${slug}`);
            break;

        case SlideTypes.Repacks:
            to = toLocalizedPath(`/${RoutePaths.RePacks}/${slug}`);
            break;
    }

    return to;
};
